import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { Group } from '../../model/group/group';
import { GroupTreeNode } from '../../model/overlay/group/group-with-overlays-tree-node';

@Injectable({
    providedIn: 'root'
})
export class GroupService {

    constructor(private readonly http: HttpClient) {
    }

    getGroups(datasetID: string, accountID: number): Observable<Group[]> {
        return this.http.get<Group[]>(`/groups/account/${ accountID }/dataset/${ datasetID }/all`);
    }

    // getGroupsAsTree(datasetID: string, accountID: number): Observable<GroupTreeNode[]> {
    //     return this.http.get<GroupTreeNode[]>(`/groups/account/${accountID}/dataset/${datasetID}/tree`);
    // }

    getGroupsAsTree(datasetID: string, accountID?: number): Observable<GroupTreeNode[]> {
        if (accountID) {
            return this.http.get<GroupTreeNode[]>(`/groups/dataset/${ datasetID }/tree`, {params: {accountId: accountID.toString()}});
        } else {
            return this.http.get<GroupTreeNode[]>(`/groups/dataset/${ datasetID }/tree`);
        }
    }

    getGroupsAsTreeForCustomScoring(datasetID: string, accountID?: number): Observable<GroupTreeNode[]> {
        if (accountID) {
            return this.http.get<GroupTreeNode[]>(`/groups/dataset/${datasetID}/cstree`, { params: { accountId: accountID.toString() } });
        } else {
            return this.http.get<GroupTreeNode[]>(`/groups/dataset/${datasetID}/cstree`);
        }
    }

    createGroup(data: any, isMoveData: boolean): Observable<Group> {
        return this.http.post<Group>(`/groups?moveData=${isMoveData}`, data);
    }

    updateGroup(data: any): Observable<Group> {
        return this.http.put<Group>(`/groups/`, data);
    }

    deleteGroup(id: number): Observable<Group> {
        return this.http.delete<Group>(`/groups/${ id }`);
    }

    bulkDeleteGroups(ids: number[]): Promise<any[]> {
        let promises = [];
        ids.forEach((id) => {
            promises.push(this.deleteGroup(id).toPromise());
        });
        return Promise.all(promises);
    }

    toggleDefaultGroup(data: any): Observable<Group> {
        return this.http.put<Group>(`/groups/default`, data);
    }

    checkIfDataExist(id: number): Observable<boolean> {
        return this.http.get<boolean>(`/groups/${id}`);
    }

    downloadData(datasetId: string, groupId: number): Observable<any> {
        return this.http.post(`/default/group/${datasetId}/${groupId}`, {}, { responseType: 'blob' });
    }

    deleteData(id: number): Observable<any> {
        return this.http.put(`/groups/${id}`,{});
    }

    fetchGroupsForMember(datasetID: string, accountID: number): Observable<Group[]> {
        return this.http.get<Group[]>(`/groups/${datasetID}/fetch?accountId=${accountID}`);
    }
    // getAllAccountApplicationGroups(accountID: number, datasetID: string): Observable<GroupDataset[]> {
    //   return this.http.get<GroupDataset[]>(`/groupNodes/account/${accountID}/dataset/${datasetID}/all`);
    // }
}
